import { connect } from 'react-redux';

import {
  projectGet,
} from '../../actions/projectActions';

import {
  collaboratorCreate,
} from '../../actions/collaboratorActions';

import ProjectJoin from './ProjectJoin';

const mapStateToProps = state => ({
  ...state.projectReducer,
});

const mapDispatchToProps = {
  projectGet,
  collaboratorCreate,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectJoin);
